import { useMemo } from 'react';
import { useImmerReducer } from 'use-immer';

import { getRequestStateFlagsWithError } from '~/utils';
import * as constants from '~/constants';

function requestReducer(
  state = { data: null, requestState: constants.REQUEST_STATES.IDLE, requestError: null },
  { type, payload },
) {
  if (Object.prototype.hasOwnProperty.call(constants.REQUEST_STATES, type)) {
    state.requestState = type; // constants.REQUEST_STATES
  }

  if (type === constants.REQUEST_STATES.PENDING) {
    state.requestError = null;
  } else if (type === constants.REQUEST_STATES.REJECTED) {
    state.requestError = payload;
  } else if (type === constants.REQUEST_STATES.FULFILLED) {
    state.data = payload;
    state.requestError = null;
  }
  return state;
}

function useRequestStates(requestState = constants.REQUEST_STATES.IDLE, requestError = null) {
  const [request, setRequest] = useImmerReducer(requestReducer, { requestState, requestError });

  const requestFlags = {
    ...getRequestStateFlagsWithError(request.requestState, request.requestError),
    data: request.data,
  };
  const requestHandlers = useMemo(() => {
    return {
      setIdle: () => setRequest({ type: constants.REQUEST_STATES.IDLE }),
      setPending: () => setRequest({ type: constants.REQUEST_STATES.PENDING }),
      setFulfilled: (data) => setRequest({ type: constants.REQUEST_STATES.FULFILLED, payload: data }),
      setRejected: (error) => setRequest({ type: constants.REQUEST_STATES.REJECTED, payload: error }),
    };
  }, []);

  return [requestFlags, requestHandlers];
}

export default useRequestStates;
